import config from "../../config";
import axios from "axios";
import underscore from "underscore";
import { setRecentlyViewed, storefrontApi } from "./shopifyAC"
import {
    extractProductIdFromStoreFrontId,
    authCheck,
    prepareShopifyUrl,
    productVariantIdToStoreFrontVariantId,
    canSeeFirstLook, getCookie, vipPreviewTimers,
} from "../common/utils";
import { getPdpVariants} from "./boostCommerceAC";
import appErrorLogger from "../common/DataDogErrorLog";
import {ModelProductList} from "../common/ModelProductList"
import { productByHandleQuery } from "./Shopify/shopify-queries/product"
import { formatShopifyProductByHandle } from "./Shopify/helpers"
import { ProductModel } from "../common/ProductModel"
import _ from "underscore"
import appInfoLogger from "../common/DataDogInfoLog"

const setAxiosInstance = (token = null) => {
    const auth_token = token || getCookie('auth_token');
    return axios.create({
        baseURL: `${config.host_rebag_api}/v6/shop/`,
        timeout: 15000,
        headers: {'Authorization': auth_token}
    });
};

const setAffirmAxiosInstance = () => {
    return axios.create({
        baseURL: `${config.affirm_api}`,
        timeout: 15000
    });
};

const getRecentlyViewed = (also_show_last_viewed_product) => {
    return (dispatch, _) => {
        const item_limit = window.innerWidth <= 768 ? 4 : 14;

        if(authCheck()){
            setAxiosInstance().get("/recently-viewed/")
                .then((response) => {
                    const recently_viewed = underscore.pluck(response.data, "store_front_id") || [];
                    if(recently_viewed.length > 0) {
                        dispatch(setRecentlyViewed(also_show_last_viewed_product ? recently_viewed : recently_viewed.slice(1, item_limit)));
                    }
                })
        } else {
            const recently_viewed = localStorage.getItem("RECENTLY_VIEWED") ? (JSON.parse(localStorage.getItem("RECENTLY_VIEWED"))).slice(1, item_limit) : [];
            if(recently_viewed.length > 0){
                dispatch(setRecentlyViewed(recently_viewed));
            }
        }
    }
};

const addRecentlyViewed = (shopify_product_id, from_login = false) => {
    return (dispatch, _) => {
        const recently_viewed = localStorage.getItem("RECENTLY_VIEWED") ? JSON.parse(localStorage.getItem("RECENTLY_VIEWED")) : [];

        if(shopify_product_id && recently_viewed.indexOf(shopify_product_id) === -1) {
            recently_viewed.unshift(shopify_product_id);
            localStorage.setItem("RECENTLY_VIEWED", JSON.stringify(recently_viewed));

            const recently_viewed_token = authCheck() ? null : config.recently_viewed_token;
            const data = {store_front_id: from_login && recently_viewed.length > 0 ? recently_viewed.join(',') : btoa(shopify_product_id)};
            setAxiosInstance(recently_viewed_token)
                .post(`/recently-viewed/`, data)
                .then(() => {
                });
        }
    }
};

const getSimilarTo = (product_id) => {
    return (dispatch, getState) => {
        const item = extractProductIdFromStoreFrontId(product_id);
        const user_profile = getState().appReducer.user_profile;

        let hide_first_look_items = '&pf_t_first_look_hidden[]=bc-filter-General View';
        if(user_profile && canSeeFirstLook(user_profile)){
            hide_first_look_items = '';
        }

        setAxiosInstance().get(`similar-to/${item}/`)
            .then((response) => {
                if(response.data.similar_items){
                    dispatch({
                        type: 'SET_SIMILAR_ITEMS',
                        similar_items_query: `${config.host_rebag_shop}/collections/new-arrivals?_=pf&build_filter_tree=true&${prepareShopifyUrl(response.data.similar_items)}`
                    })
                }
                if(response.data.same_designer){
                    dispatch({
                        type: 'SET_SIMILAR_SAME_DESIGNER',
                        products: [],
                        total_products: 0,
                        filter_query: `${config.host_rebag_shop}/collections/new-arrivals?_=pf&build_filter_tree=true&${prepareShopifyUrl(response.data.same_designer + hide_first_look_items)}`
                    });
                }
                if(response.data.other_designers){
                    dispatch({
                        type: 'SET_SIMILAR_OTHER_DESIGNERS',
                        products: [],
                        total_products: 0,
                        filter_query: `${config.host_rebag_shop}/collections/new-arrivals?_=pf&build_filter_tree=true&${prepareShopifyUrl(response.data.other_designers + hide_first_look_items)}`
                    });
                }
                if(response.data.matching_accessories){
                    dispatch({
                        type: 'SET_MATCHING_ACCESSORIES',
                        products: [],
                        total_products: 0,
                        filter_query: `${config.host_rebag_shop}/collections/new-arrivals?_=pf&build_filter_tree=true&${prepareShopifyUrl(response.data.matching_accessories + hide_first_look_items)}`
                    });
                }
                if(response.data.matching_bags){
                    dispatch({
                        type: 'SET_MATCHING_BAGS',
                        products: [],
                        total_products: 0,
                        filter_query: `${config.host_rebag_shop}/collections/new-arrivals?_=pf&build_filter_tree=true&${prepareShopifyUrl(response.data.matching_bags + hide_first_look_items)}`
                    });
                }
            })
            .catch((error) => appErrorLogger('PDP Get Similar To', error))
    }
};

const getOthersYouMayLikeRecommendation = (product_id) => {
    return (dispatch, getState) => {
        const item = extractProductIdFromStoreFrontId(product_id);
        const can_see_first_look_items = authCheck() && getCookie("can_see_first_look") === "true";
        const {must_show_navbar_message} = vipPreviewTimers();

        setAxiosInstance().get(`other-you-may-like/product/${item}/${can_see_first_look_items && must_show_navbar_message ? "?with_vip_preview=1" : ""}`)
            .then((response) => {
                if(response.data){
                    dispatch({
                        type: 'SET_OTHERS_RECOMMENDATION_ITEMS',
                        payload: ModelProductList(response.data.products),
                    })
                }
            })
            .catch((error) => appErrorLogger('PDP Get Others You May Like', error))
    }
}

const getSimilarItemsRecommendation = (product_id) => {
    return (dispatch, getState) => {
        const item = extractProductIdFromStoreFrontId(product_id);
        const can_see_first_look_items = authCheck() && getCookie("can_see_first_look") === "true";
        const {must_show_navbar_message} = vipPreviewTimers();

        setAxiosInstance().get(`similar-items/product/${item}/${can_see_first_look_items && must_show_navbar_message ? "?with_vip_preview=1" : ""}`)
            .then((response) => {
                if(response.data){
                    dispatch({
                        type: 'SET_SIMILAR_RECOMMENDATION_ITEMS',
                        payload: ModelProductList(response.data.products),
                    })
                }
            })
            .catch((error) => appErrorLogger('PDP Get Similar Items', error))
    }
}

const getAffirmMonthlyPayments = (amount) => {
    return (dispatch, _) => {
        const affirm_token = "OPRFJKQ8G8G2JEI0";
        setAffirmAxiosInstance().get(`${affirm_token}?amount=${amount}`)
            .then((response) => {
                dispatch({
                    type: "GET_AFFIRM_MONTHLY_PAYMENT",
                    affirm_monthly_payment: response.data
                })
            })
            .catch((error) => appErrorLogger('PDP Get Affirm Monthly Payments', error))
    }
};

const hideSpinner = () => {
    return (dispatch, _) => {
        dispatch({type: "HIDE_SPINNER"});
    }
};

const getColorSizes = (clair_code) => {
    return (dispatch, _) => {
        setAxiosInstance().get(`/extra/${clair_code}/`)
            .then((response) => {
                dispatch({
                    type: "GET_COLOR_SIZES",
                    payload: response.data
                })
            })
            .catch((error) => appErrorLogger('PDP Get Colors and Sizes', error))
    }
}

const getExchangePeriodsValues = (price) => {
    return (dispatch, _) => {
        setAxiosInstance().get(`/exchange-periods-values/${parseInt(price)}/`)
            .then((response) => {
                dispatch({
                    type: "GET_EXCHANGE_PERIODS_VALUES",
                    exchange_periods_values: response.data
                })
            })
            .catch((error) => appErrorLogger('PDP Get Exchange Periods', error))
    }
}

const renderAuthPopup = (login_type, callback, msg = null, dismiss_able = true) => {
    return (dispatch, _) => {
        if(callback){
            window.next_action = callback;
        }
        dispatch({
            type: "OPEN_LOGIN_MODAL",
            login_type: login_type,
            modal_opened: true,
            signup_msg: msg,
            dismiss_able: dismiss_able
        });
    }
}

const getProductsByPdpVariants = (url, refinements) => {
    return (dispatch, getState) => {
        let updateRefinements = [...refinements];
        getPdpVariants(refinements, getState().appReducer.isBoostDown)
            .then((response) => {
                const {records} = response.data;
                let available_products = records.filter(x => x.allMeta.availability === 'IN_STOCK').length;
                if (available_products < 6) {
                    updateRefinements = updateRefinements.filter(x => {
                      return x.navigationName !== 'attributes.pf_t_style'
                    })
                    getPdpVariants(updateRefinements, getState().appReducer.isBoostDown)
                        .then((response) => {
                            const {records} = response.data
                            if (available_products > 1) {
                                if (records[0].available) {
                                    document.location.href = url + '&pf_st_availability_hidden=true';
                                } else {
                                    document.location.href = url;
                                }
                            } else {
                                document.location.href = config.host_rebag_shop + '/products/' + records[0].allMeta.attributes.handle.text[0];
                            }
                        })
                        .catch((error) => {
                            appErrorLogger('getPdpVariants error 2', error)
                            window.location.reload()
                        })
                } else {
                    if (records[0].allMeta.availability === 'IN_STOCK') {
                        document.location.href = url + '&pf_st_availability_hidden=true';
                    } else {
                        document.location.href = url;
                    }
                }
            })
            .catch((error) => {
                appErrorLogger('getPdpVariants error 1', error)
                window.location.reload()
            })
    }
}

const getCustomProductByHandle = (handle, external_selected_variant = null, country) => {
    return (dispatch, getState) => {
        return new Promise (async (resolve) => {
            const init = JSON.parse(localStorage.getItem('init'));
            const selectedCountry = country ? country : getState().appReducer.selectedCountry;
            storefrontApi(productByHandleQuery, {handle}).then(formatShopifyProductByHandle).then((productByHandle) => {
                if (productByHandle) {
                    const product = ProductModel(productByHandle, selectedCountry, init);
                    const selected_variant = _.find(product.product_variants, (variant) => {
                        return external_selected_variant === variant.title;
                    }) || null;
                    dispatch({
                        type: "GET_CUSTOM_PRODUCT_BY_HANDLE",
                        product: product,
                        selected_product: selected_variant ? selected_variant.id : null,
                        selected_product_title: selected_variant ? selected_variant.title : null
                    });

                    // Skip FB recently viewed POST
                    const user_agent = navigator.userAgent;
                    if(user_agent.indexOf('facebookexternalhit/') === -1 && user_agent.indexOf('Facebot') === -1){
                        dispatch(addRecentlyViewed(productByHandle.id));
                        dispatch(getOthersYouMayLikeRecommendation(productByHandle.id));
                        dispatch(getSimilarItemsRecommendation(productByHandle.id));
                    }
                    if (productByHandle.data && productByHandle.data.errors) {
                        appInfoLogger('Get product by handle:: ' + handle, productByHandle.data.errors, {product: productByHandle});
                    }
                    resolve(product);
                } else {
                    dispatch({type: "HIDE_SPINNER"});
                    dispatch({
                        type: "SHOPIFY_PRODUCT_NOT_FOUND"
                    });
                    resolve(null);
                }
            }).catch((errors) => {
                appErrorLogger('Get product by handle:: ' + handle, errors, {errorObject: errors});
                dispatch({type: "HIDE_SPINNER"});
                dispatch({
                    type: "SHOPIFY_PRODUCT_NOT_FOUND"
                });
                resolve(null);
            });
        })
    }
};

export {
    getRecentlyViewed,
    addRecentlyViewed,
    getSimilarTo,
    getAffirmMonthlyPayments,
    hideSpinner,
    getExchangePeriodsValues,
    renderAuthPopup,
    getProductsByPdpVariants,
    getColorSizes,
    getOthersYouMayLikeRecommendation,
    getSimilarItemsRecommendation,
    getCustomProductByHandle
}